import Select from 'react-select';

export default function DataSourceValueList(props) {

    return(
        <div data-cy="DataSourceValueList">
            <Select 
                placeholder="Select Datasource Value List"
                required={true}
                options={props.dataSources}
                value={props.values.dataSource}
                onChange={item => {
                    props.onItemChanged(props.values.id, 'dataSource', item);
                    props.onItemChanged(props.values.id, 'sourceType', 'dynamic');
                }}
                isClearable={true}
                data-cy="DataSourceValueList-Select"
            />
        </div>
    );
}
